import { render, staticRenderFns } from "./WorkboardStatus.vue?vue&type=template&id=b5ee806c"
import script from "./WorkboardStatus.vue?vue&type=script&lang=js"
export * from "./WorkboardStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports